import { CUSTOM_ELEMENTS_SCHEMA, Component, computed, input, output } from '@angular/core';
import { janelaPaginas } from '../../../core/utils/parametros/planos.util';

@Component({
  selector: 'app-pagination',
  imports: [],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PaginationComponent {
  readonly currentPage = input(1);
  readonly pageSize = input(10);
  readonly totalItems = input(0);
  /** Quantidades oferecidas em "Mostrar 10 | 50 | 100 Itens por página", como em Planos. */
  readonly pageSizeOptions = input<readonly number[]>([10, 50, 100]);

  readonly pageChange = output<number>();
  readonly pageSizeChange = output<number>();

  readonly totalPages = computed(() => {
    const size = this.pageSize();
    if (size <= 0) {
      return 1;
    }
    return Math.max(1, Math.ceil(this.totalItems() / size));
  });

  /** Até 5 números de página em volta da atual, como na paginação de Planos. */
  readonly pages = computed(() => janelaPaginas(this.currentPage(), this.totalPages()));

  /**
   * Aparece quando os itens não cabem no menor tamanho de página — mesmo que caibam no tamanho
   * escolhido, para dar como voltar a um tamanho menor.
   */
  readonly visible = computed(() => {
    const menor = Math.min(this.pageSize(), ...this.pageSizeOptions());
    return this.totalItems() > menor;
  });

  readonly canGoPrevious = computed(() => this.currentPage() > 1);
  readonly canGoNext = computed(() => this.currentPage() < this.totalPages());

  /** Emite só quando a quantidade muda; quem usa volta para a primeira página. */
  changePageSize(size: number): void {
    if (size !== this.pageSize()) {
      this.pageSizeChange.emit(size);
    }
  }

  /** Emite só para uma página válida e diferente da atual. */
  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages() && page !== this.currentPage()) {
      this.pageChange.emit(page);
    }
  }
}
